<template>
    <v-app>
        <v-main class="fondo-login">
            <v-container>
                <v-row class="mt-15 justify-center">
                    <v-col cols="12" xl="4" lg="4" md="6" sm="12">
                        <v-card class="border-login">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12 text-center" v-if="loading">
                                        <v-progress-circular indeterminate color="primary" :size="100" :width="7" />
                                    </v-col>

                                    <slot v-else></slot>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style scoped>
    .border-login {
        border: 1px solid rgba(35, 201, 243, 0.884);
    }

    .fondo-login {
        background-image: url('https://prooptimania.s3.us-east-2.amazonaws.com/ckfinder/images/optica-local-medida-de-vista-receta.jpg');
        /* Full height */
        height: 100%;

        /* Center and scale the image nicely */
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>
